module.exports = {
  language: {
    name: 'English'
  },
  layout:{
    myself:'个人中心',
    loginOut:'退出',
  },
  index:{
    clientOrder:'客户下单',
    business:'后台接单',
    clientSend:'客户寄样',
    testType:'检测类型',
    testTypeRemark:'请客户选择检测类型进行下单',
    version:'版本',
    new:'新',
    old:'旧',
  },
  user: {
    login:'登录',
    register:'注册',
    loginUsername:'请输入邮箱/手机号',
  },
  order:{
    sampleBasicInformation:'样品基本信息',
    sampleName:'样品名称',
    inputSampleName:'请输入样品名称',
    sampleElement:'样品元素',
    inputSampleElement:'请输入样品元素',
    sampleQuantity:'样品数量',
    sampleSync:'编号同步',
    inputSampleSync:'将下面所有样品编号同步',
    sampleNumber:'样品编号',
    inputSampleNumber:'请输入样品编号',
    orderRemark:'订单备注',
    inputOrderRemark:'请输入订单备注',
  }
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js